import React from 'react';
import { useAuth } from '../../context/AuthContext';

const ParentProfile = () => {
  const { user } = useAuth();

  const initials = user?.name
    ? user.name.split(' ').map((n) => n[0]).join('').slice(0, 2).toUpperCase()
    : 'P';

  return (
    <div className="p-6 lg:p-8 bg-white min-h-screen">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-[#0A0A0A]">👤 Mon profil</h1>
        <p className="text-gray-500 mt-1">Vos informations personnelles</p>
      </div>

      <div className="max-w-2xl">
        <div className="bg-gradient-to-r from-[#0A0A0A] to-[#F39C12] rounded-2xl p-6 mb-6 text-white">
          <div className="flex items-center gap-5">
            <div className="w-20 h-20 rounded-full bg-white/20 backdrop-blur flex items-center justify-center text-white text-2xl font-bold">
              {initials}
            </div>
            <div>
              <h2 className="text-2xl font-bold">{user?.name || 'Parent'}</h2>
              <p className="text-white/90 text-sm mt-1">{user?.email}</p>
              <span className="inline-block mt-2 px-3 py-1 rounded-full bg-white/20 text-xs font-medium">
                Parent
              </span>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-gray-100 p-6 space-y-4">
          <InfoRow label="Nom complet" value={user?.name || '-'} />
          <InfoRow label="Email" value={user?.email || '-'} />
          <InfoRow label="Rôle" value="Parent" />
          <InfoRow label="Téléphone" value={user?.phone || '-'} />
        </div>
      </div>
    </div>
  );
};

function InfoRow({ label, value }) {
  return (
    <div className="flex justify-between items-center py-3 border-b border-gray-100 last:border-0">
      <span className="text-sm text-gray-500">{label}</span>
      <span className="text-sm font-medium text-[#0A0A0A]">{value}</span>
    </div>
  );
}

export default ParentProfile;